import { useApiClient } from '@/composables/api/client'
import type {
  IndexFilterResponse,
  IndexFilterVariables,
} from '@/types/api/filter'

export const useApiFilter = () => {
  const { apiClient } = useApiClient()

  const index = (params: IndexFilterVariables) =>
    apiClient.get<IndexFilterResponse>('filters', {
      params,
    })

  return { index }
}
